import { useMemo } from 'react';
import { ResponsiveQuery } from '@/types/responsive';
import { smallMobile, mobile, tablet, desktop, mediumDesktop, bigDesktop, hugeDesktop } from '@/constants/screensizes';
import useMediaQuery from '../useMediaQuery';

const useResponsiveValue = <T = unknown>(query: ResponsiveQuery<T>) => {
  const [width] = useMediaQuery();

  const value = useMemo(() => {
    const values = [query.base];

    if (width >= smallMobile) values.push(query.xs);
    if (width >= mobile) values.push(query.sm);
    if (width >= tablet) values.push(query.md);
    if (width >= desktop) values.push(query.lg);
    if (width >= mediumDesktop) values.push(query.xl);
    if (width >= bigDesktop) values.push(query['2xl']);
    if (width >= hugeDesktop) values.push(query['3xl']);

    // Last value that was actually provided. Filter only unset breakpoints
    // (null / undefined) — NOT all falsy values, or a legitimate `0` (e.g. a
    // zero-gap `spaceBetween`) would be dropped and fall back to a default.
    return values.filter((value) => value != null).at(-1);
  }, [width, query]);

  return value;
};

export default useResponsiveValue;
